// Module
var code = "<react-attack-event-drilldown organizationId=\"main.currentOrg\" eventUuid=\"attackEventDashboardCtrl.getEventUuid()\"></react-attack-event-drilldown>";
// Exports
var _module_exports =code;;
var path = '/views/attacks/attack_event_drilldown.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;